'use client';

import { useCallback, useRef } from 'react';
import { useIsomorphicLayoutEffect } from '../useIsomorphicLayoutEffect';

/**
 * takes in a callback function, puts it into a ref and returns a render-stable
 * callback that calls that ref's current value
 * @param callback - the callback to wrap in a ref
 */
export const useStableCallback = <
  T extends (...args: [...unknown[]]) => unknown
>(
  callback: T
) => {
  const callbackRef = useRef<T>(callback);
  useIsomorphicLayoutEffect(() => {
    callbackRef.current = callback;
  });

  return useCallback(
    (...args: [...unknown[]]) => callbackRef.current?.(...args),
    []
  ) as T;
};
